const a = ":host{display:contents}.sl-tab{display:inline-flex;flex:0 0 auto;width:max-content;align-items:center;justify-content:center;gap:var(--sl-spacing-2);padding:var(--sl-spacing-2) var(--sl-spacing-4);background:transparent;border:none;border-bottom:2px solid transparent;color:hsl(var(--sl-hsl-muted-foreground));font-family:var(--sl-font-family-base);font-size:var(--sl-font-size-sm);font-weight:var(--sl-font-weight-medium);cursor:pointer;transition:all var(--sl-transition-fast);white-space:nowrap;overflow:var(--sl-tab-overflow,visible);text-overflow:var(--sl-tab-text-overflow,clip);max-width:var(--sl-tab-max-width,none);outline:none}.sl-tab:hover:not(.sl-tab--disabled):not(.sl-tab--active){color:hsl(var(--sl-hsl-secondary-foreground));background-color:hsl(var(--sl-hsl-secondary))}.sl-tab:focus-visible{box-shadow:0 0 0 2px hsl(var(--sl-hsl-background)),0 0 0 4px hsl(var(--sl-hsl-ring))}.sl-tab--active{color:hsl(var(--sl-hsl-primary));border-bottom-color:hsl(var(--sl-hsl-primary));background-color:transparent}.sl-tab--disabled{cursor:not-allowed;opacity:0.5;pointer-events:none}.sl-tab--xs{padding:var(--sl-spacing-1) var(--sl-spacing-2);font-size:var(--sl-font-size-xs)}.sl-tab--sm{padding:var(--sl-spacing-1) var(--sl-spacing-3);font-size:var(--sl-font-size-xs)}.sl-tab--lg{padding:var(--sl-spacing-3) var(--sl-spacing-6);font-size:var(--sl-font-size-base)}.sl-tab__icon{flex-shrink:0;width:1rem;height:1rem}";
class i extends HTMLElement {
  constructor() {
    super(), this._handleClickBound = this._handleClick.bind(this), this._shadow = this.attachShadow({ mode: "open" }), this._button = document.createElement("button"), this._render();
  }
  static get observedAttributes() {
    return ["name", "disabled", "size", "active"];
  }
  connectedCallback() {
    this._button.addEventListener("click", this._handleClickBound), this._updateTab();
  }
  disconnectedCallback() {
    this._button.removeEventListener("click", this._handleClickBound);
  }
  attributeChangedCallback(t, e, s) {
    e !== s && this._updateTab();
  }
  _handleClick(t) {
    if (this.disabled) return;
    this.dispatchEvent(
      new CustomEvent("sl-tab-click", {
        bubbles: !0,
        composed: !0,
        detail: { tab: this }
      })
    );
    const e = this.parentElement, s = this.name;
    e?.tagName === "SL-TABS" && s !== null && e._setActiveTab(s);
  }
  get name() {
    return this.getAttribute("name");
  }
  set name(t) {
    t ? this.setAttribute("name", t) : this.removeAttribute("name");
  }
  get disabled() {
    return this.hasAttribute("disabled");
  }
  set disabled(t) {
    t ? this.setAttribute("disabled", "") : this.removeAttribute("disabled");
  }
  get size() {
    return this.getAttribute("size") || "default";
  }
  set size(t) {
    this.setAttribute("size", t);
  }
  _updateTab() {
    this._button && (this._button.className = this._getTabClasses(), this._button.setAttribute("role", "tab"), this._button.setAttribute("aria-selected", this.hasAttribute("active") ? "true" : "false"), this._button.setAttribute("tabindex", this.hasAttribute("active") ? "0" : "-1"), this.disabled ? this._button.setAttribute("aria-disabled", "true") : this._button.removeAttribute("aria-disabled"));
  }
  _getTabClasses() {
    const t = ["sl-tab"];
    return this.hasAttribute("active") && t.push("sl-tab--active"), this.disabled && t.push("sl-tab--disabled"), this.size && this.size !== "default" && t.push(`sl-tab--${this.size}`), t.join(" ");
  }
  _render() {
    this._shadow.innerHTML = `
      <style>${a}</style>
      <button
        part="button"
        class="${this._getTabClasses()}"
        role="tab"
        aria-selected="${this.hasAttribute("active") ? "true" : "false"}"
        tabindex="${this.hasAttribute("active") ? "0" : "-1"}"
        ${this.disabled ? "disabled" : ""}
      >
        <slot></slot>
      </button>
    `, this._button = this._shadow.querySelector("button");
  }
}
typeof customElements < "u" && !customElements.get("sl-tab") && customElements.define("sl-tab", i);
export {
  i as SlTabElement
};
//# sourceMappingURL=sl-tab.js.map
